<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 480 480" style="enable-background:new 0 0 480 480;" xml:space="preserve">
<g>
	<g>
		<path d="M277.648,97.336C288.888,87.088,296,72.376,296,56c0-30.872-25.12-56-56-56s-56,25.128-56,56
			c0,16.376,7.112,31.088,18.352,41.336C169.16,103.736,144,132.968,144,168v32c0,4.424,3.584,8,8,8h176c4.416,0,8-3.576,8-8v-32
			C336,132.968,310.84,103.736,277.648,97.336z M200,56c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40
			c0,22.056-17.944,40-40,40C217.944,96,200,78.056,200,56z M320,192H160v-24c0-30.872,25.12-56,56-56h48c30.88,0,56,25.128,56,56
			V192z"/>
	</g>
</g>
<g>
	<g>
		<path d="M133.648,369.336C144.888,359.088,152,344.376,152,328c0-30.872-25.12-56-56-56s-56,25.128-56,56
			c0,16.376,7.112,31.088,18.352,41.336C25.16,375.736,0,404.968,0,440v32c0,4.424,3.584,8,8,8h176c4.416,0,8-3.576,8-8v-32
			C192,404.968,166.84,375.736,133.648,369.336z M56,328c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40
			c0,22.056-17.944,40-40,40C73.944,368,56,350.056,56,328z M176,464H16v-24c0-30.872,25.12-56,56-56h48c30.88,0,56,25.128,56,56
			V464z"/>
	</g>
</g>
<g>
	<g>
		<path d="M421.648,369.336C432.888,359.088,440,344.376,440,328c0-30.872-25.12-56-56-56s-56,25.128-56,56
			c0,16.376,7.112,31.088,18.352,41.336C313.16,375.736,288,404.968,288,440v32c0,4.424,3.584,8,8,8h176c4.416,0,8-3.576,8-8v-32
			C480,404.968,454.84,375.736,421.648,369.336z M344,328c0-22.056,17.944-40,40-40c22.056,0,40,17.944,40,40
			c0,22.056-17.944,40-40,40C361.944,368,344,350.056,344,328z M464,464H304v-24c0-30.872,25.12-56,56-56h48
			c30.88,0,56,25.128,56,56V464z"/>
	</g>
</g>
<g>
	<g>
		<path d="M48.152,255.744l-15.984,0.624c0.216,5.512,0.656,11.096,1.312,16.584l15.888-1.904
			C48.76,265.984,48.352,260.832,48.152,255.744z"/>
	</g>
</g>
<g>
	<g>
		<path d="M33.472,223.176c-0.648,5.456-1.096,11.032-1.304,16.576l15.984,0.624c0.2-5.12,0.608-10.264,1.208-15.312L33.472,223.176
			z"/>
	</g>
</g>
<g>
	<g>
		<path d="M113.912,82.544c-4.376,3.336-8.688,6.904-12.824,10.616l10.696,11.904c3.808-3.424,7.784-6.72,11.824-9.792
			L113.912,82.544z"/>
	</g>
</g>
<g>
	<g>
		<path d="M51.736,159.44c-2.352,5-4.528,10.152-6.48,15.344l14.976,5.624c1.8-4.784,3.808-9.536,5.976-14.136L51.736,159.44z"/>
	</g>
</g>
<g>
	<g>
		<path d="M40.024,190.584c-1.52,5.288-2.84,10.736-3.936,16.16l15.688,3.16c1.008-5,2.224-10.024,3.632-14.912L40.024,190.584z"/>
	</g>
</g>
<g>
	<g>
		<path d="M89.176,104.776c-3.832,4.032-7.512,8.232-10.968,12.496l12.44,10.064c3.184-3.936,6.592-7.824,10.128-11.544
			L89.176,104.776z"/>
	</g>
</g>
<g>
	<g>
		<path d="M141.864,64.568c-4.84,2.584-9.664,5.424-14.352,8.44l8.672,13.456c4.32-2.792,8.768-5.408,13.216-7.784L141.864,64.568z"
			/>
	</g>
</g>
<g>
	<g>
		<path d="M68.272,130.6c-3.128,4.568-6.104,9.304-8.848,14.096l13.88,7.952c2.528-4.416,5.28-8.792,8.168-13L68.272,130.6z"/>
	</g>
</g>
<g>
	<g>
		<path d="M202.096,436.256l-3.16,15.688c5.384,1.088,10.92,1.96,16.448,2.608l1.856-15.888
			C212.16,438.064,207.056,437.256,202.096,436.256z"/>
	</g>
</g>
<g>
	<g>
		<path d="M278.408,436.16c-4.968,1.008-10.064,1.832-15.168,2.456l1.928,15.888c5.52-0.672,11.04-1.568,16.416-2.656
			L278.408,436.16z"/>
	</g>
</g>
<g>
	<g>
		<path d="M247.944,439.84c-5.112,0.2-10.28,0.224-15.36,0.024l-0.632,15.984c2.664,0.112,5.352,0.16,8.072,0.16
			c2.864-0.016,5.72-0.072,8.56-0.184L247.944,439.84z"/>
	</g>
</g>
<g>
	<g>
		<path d="M378.944,93.224l-10.688,11.904c3.808,3.424,7.504,7.024,11,10.704l11.616-11
			C387.08,100.832,383.072,96.928,378.944,93.224z"/>
	</g>
</g>
<g>
	<g>
		<path d="M401.824,117.32l-12.44,10.064c3.192,3.944,6.28,8.096,9.176,12.32l13.192-9.048
			C408.616,126.088,405.28,121.6,401.824,117.32z"/>
	</g>
</g>
<g>
	<g>
		<path d="M447.832,239.776l-15.984,0.624c0.104,2.52,0.152,5.064,0.152,7.6c0,2.6-0.048,5.184-0.152,7.768l15.984,0.624
			c0.112-2.784,0.168-5.584,0.168-8.408C448,245.24,447.944,242.496,447.832,239.776z"/>
	</g>
</g>
<g>
	<g>
		<path d="M420.608,144.736l-13.888,7.96c2.536,4.424,4.92,9.008,7.096,13.616l14.472-6.832
			C425.936,154.488,423.352,149.528,420.608,144.736z"/>
	</g>
</g>
<g>
	<g>
		<path d="M434.76,174.816l-14.976,5.632c1.792,4.768,3.408,9.672,4.816,14.568l15.384-4.408
			C438.464,185.296,436.704,179.984,434.76,174.816z"/>
	</g>
</g>
<g>
	<g>
		<path d="M443.904,206.776l-15.68,3.152c1.008,5.008,1.824,10.112,2.416,15.168l15.888-1.888
			C445.88,217.736,445,212.208,443.904,206.776z"/>
	</g>
</g>
<g>
	<g>
		<path d="M352.536,73.04l-8.664,13.456c4.272,2.752,8.496,5.72,12.568,8.832l9.712-12.728
			C361.744,79.232,357.168,76.024,352.536,73.04z"/>
	</g>
</g>
<g>
	<g>
		<path d="M323.232,57.328l-6.408,14.656c4.664,2.04,9.304,4.296,13.808,6.712L338.2,64.6
			C333.328,61.976,328.288,59.528,323.232,57.328z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
